/**
 * Imperative offline badge on document.body — avoids React/CSS-module timing
 * and body-as-flex-item issues with position:fixed overlays.
 */
const ID = 'bly-kiosk-offline-indicator';

export function mountKioskOfflineIndicator() {
  if (typeof document === 'undefined') {
    return () => {};
  }

  const existing = document.getElementById(ID);
  if (existing) existing.remove();

  const el = document.createElement('div');
  el.id = ID;
  el.title = 'Offline';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  el.setAttribute('aria-label', 'Offline');

  const bars = document.createElement('div');
  Object.assign(bars.style, {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '3px',
    height: '14px',
  });
  const heights = ['5px', '14px', '9px'];
  for (let i = 0; i < 3; i += 1) {
    const span = document.createElement('span');
    Object.assign(span.style, {
      display: 'block',
      width: '3px',
      height: heights[i],
      borderRadius: '1px',
      background: 'rgba(255,255,255,0.95)',
    });
    bars.appendChild(span);
  }

  const label = document.createElement('span');
  label.textContent = 'Off';
  Object.assign(label.style, {
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.06em',
    color: 'rgba(255,248,220,0.98)',
    textTransform: 'uppercase',
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1',
  });

  Object.assign(el.style, {
    position: 'fixed',
    left: '12px',
    bottom: '12px',
    zIndex: '2147483647',
    display: 'none',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 10px',
    background: 'rgba(10,61,98,0.94)',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.35)',
    pointerEvents: 'none',
    minWidth: 'max-content',
  });

  el.appendChild(bars);
  el.appendChild(label);
  document.body.appendChild(el);

  const sync = () => {
    el.style.display = navigator.onLine ? 'none' : 'flex';
  };

  sync();
  window.addEventListener('online', sync);
  window.addEventListener('offline', sync);

  return () => {
    window.removeEventListener('online', sync);
    window.removeEventListener('offline', sync);
    el.remove();
  };
}
